"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Variants = exports.Shape = exports.Size = void 0;
/** @jsx jsx */
var react_1 = __importDefault(require("react"));
var react_2 = require("@emotion/react");
var Icon_1 = __importDefault(require("../Icon/Icon"));
var constants_1 = require("../Icon/constants");
Object.defineProperty(exports, "Size", { enumerable: true, get: function () { return constants_1.Size; } });
Object.defineProperty(exports, "Shape", { enumerable: true, get: function () { return constants_1.Shape; } });
Object.defineProperty(exports, "Variants", { enumerable: true, get: function () { return constants_1.Variants; } });
var disabledStyle = react_2.css({
    pointerEvents: 'none',
    opacity: '0.5',
});
var IconButton = react_1.default.memo(function (_a) {
    var iconButtonType = _a.iconButtonType, _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, _d = _a.shape, shape = _d === void 0 ? 'square' : _d, disabled = _a.disabled, pointer = _a.pointer, props = __rest(_a, ["iconButtonType", "size", "variant", "shape", "disabled", "pointer"]);
    var style = react_2.css({
        display: 'inline-flex',
        position: 'relative',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        height: constants_1.buttonSizeMap[size].height,
        width: constants_1.buttonSizeMap[size].width,
        border: constants_1.variantMap[variant].border,
        backgroundColor: constants_1.variantMap[variant].backgroundColor,
        borderRadius: constants_1.iconShapeMap[shape].borderRadius,
        cursor: pointer ? 'pointer' : 'initial',
    });
    var icon = (react_2.jsx("div", __assign({ css: [style, disabled ? disabledStyle : undefined] }, props),
        react_2.jsx(Icon_1.default, { type: iconButtonType, size: size })));
    return icon;
});
exports.default = IconButton;
